import { ListManager, PageHeader, Styles } from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterCastrations from '../../components/FilterCastrations'

function CastrationsOperationalSummary({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(
    reports.castrationsOperationalSummary,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Resumo operacional de castrações"
        subtitle="Quantidade de castrações em cada fase operacional"
        icon="fas fa-list-ol"
        rightAction={() => <FilterCastrations />}
      />
      <ListManager
        count={Object.keys(data?.totals || {}).length}
        loading={loading}
        error={error}
      >
        <table className="table table-hover text-small">
          <thead>
            <tr>
              <th>Status</th>
              <th className="text-right" width="200px">
                Quantidade
              </th>
            </tr>
          </thead>
          <tbody>
            {Boolean(data?.totals)
              && Object.values(data.totals).map((row) => (
                <tr key={row.title}>
                  <td>{row.title}</td>
                  <td className="text-right">{row.total}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </ListManager>
    </Styles.Container>
  )
}

export default CastrationsOperationalSummary
